module.exports = function() {
  return new Worker(__webpack_public_path__ + "29c1ddc7dcea216cc45e.worker.js");
};